import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-voyeurism-free',
  templateUrl: './voyeurism-free.component.html',
  styleUrls: ['./voyeurism-free.component.scss']
})
export class VoyeurismFreeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
